import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import { addAlert } from '../../store/actions/alertActions';
import { addToScore, subtractFromScore } from '../../store/actions/skillActions';
import withActivityAnalytics from '../../hoc/WithActivityAnalytics';
import { TYPES, ENDGAME_ID } from '../../constants/activityTypes';

class GameActivity extends Component {
    constructor(props) {
        super(props);
        this.score = 0;
        this.endGameData = null;
        this.interval = '';
        this.recordId = null;

        const { demoMode } = this.props;

        this.pushAnalytics = this.pushAnalytics.bind(this);
        this.pushEndGameAnalytics = this.pushEndGameAnalytics.bind(this);
        this.updateEndGameAnalytics = this.updateEndGameAnalytics.bind(this);
        this.studentBox = document.getElementsByClassName('student-box2')[0];
    }

    static ACTIONS_TYPES = {
        ALERT: 'alert',
        ADD_SCORE: 'add_score',
        SUBTRACT_SCORE: 'subtract_score',
        FINISHED: 'finished',
        REDIRECT: 'redirectTo',
        ENDLESSONSTATS: 'endLessonStats',
        UNITY_WRITTEN_RESPONSE: 'UNITY_WRITTENRESPONSE',
        UNITY_READY: 'UNITY_READY',
        ERROR: 'error',
    };

    componentDidMount() {
        window.addEventListener('message', this.handleFrameTasks);
        if (this.studentBox) {
            this.studentBox.classList.add('gamebox');
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleFrameTasks);
        if (this.endGameData !== null) {
            this.updateEndGameAnalytics();
        }
        clearInterval(this.interval);
        if (this.studentBox) {
            this.studentBox.classList.remove('gamebox');
        }
    }

    handleFrameTasks = (e) => {
        let message = null;
        try {
            message = JSON.parse(e.data);
        } catch (e) {
            console.log(e);
        }
        if (!message) return;

        const { type } = message;

        if (type === GameActivity.ACTIONS_TYPES.ALERT) {
            const alertMessgae = {
                text: message.text,
                voice: 'Justin',
            };
            this.props.dispatchAddAlert(alertMessgae);
        } else if (type === GameActivity.ACTIONS_TYPES.FINISHED) {
            this.pushAnalytics(message);

            this.props.activityDone();
        } else if (type === GameActivity.ACTIONS_TYPES.ADD_SCORE) {
            this.props.dispatchAddToScore(message.category, message.score);
        } else if (type === GameActivity.ACTIONS_TYPES.SUBTRACT_SCORE) {
            this.props.dispatchSubtractFromScore(message.category, message.score);
        } else if (type === GameActivity.ACTIONS_TYPES.REDIRECT) {
            // (message);
            this.pushAnalytics(message);
            this.props.gotoActivity(message.index);
        } else if (type === GameActivity.ACTIONS_TYPES.ENDLESSONSTATS) {
            let gameInfo = JSON.parse(message.score);
            this.endGameData = gameInfo.data;
            //this.props.saveEndLessonActivityStats( this.props.auth.student.id, message)
            if (this.recordId === null) {
                this.pushEndGameAnalytics();
            }
        } else if (type === GameActivity.ACTIONS_TYPES.UNITY_WRITTEN_RESPONSE) {
            this.pushAnalyticsUnity(message.message);
        } else if (type === GameActivity.ACTIONS_TYPES.ERROR) {
            //add log or notifty devs-conternt team
            console.log('Error received');

            // do not proceed as it is teacher preview
        }
    };

    pushAnalyticsUnity = (text) => {
        if (this.props.demoMode) return;
        //push the analytics
        const { activityId, startTime, endTime } = this.props;

        const resultObj = {
            correct: 0,
            teacherAssessed: 0,
            text,
        };

        const activitiesEndedAt = endTime();

        this.props.pushActivityAnalytics(startTime, activitiesEndedAt, 310, activityId, resultObj);
    };

    pushAnalytics = (data) => {
        if (this.props.demoMode) return;
        //push the analytics
        const { activityId, startTime, endTime } = this.props;

        const { score } = data;

        const gameScore = !score ? 0 : Math.floor(score);

        const resultObj = {
            correct: gameScore,
        };

        const activitiesEndedAt = endTime();

        this.props.pushActivityAnalytics(startTime, activitiesEndedAt, TYPES.GAME.ID, activityId, resultObj);
    };

    pushEndGameAnalytics = async () => {
        if (this.props.demoMode) return;
        //push the analytics
        const { activityId, startTime, endTime } = this.props;

        const activitiesEndedAt = endTime();

        const result = await this.props.pushActivityAnalytics(
            startTime,
            activitiesEndedAt,
            ENDGAME_ID,
            activityId,
            this.endGameData
        );

        this.recordId = result.recordId;
        this.interval = setInterval(() => {
            this.updateEndGameAnalytics();
        }, 30000);
    };

    updateEndGameAnalytics = async () => {
        if (this.props.demoMode) return;
    };

    render() {
        //get from url request
        //this type of request will run from the actual lesson
        const { gameName } = this.props.match.params;

        //get game from props
        //this type of request will run from preview
        const { assetPath } = this.props;

        let game = null;
        if (gameName) {
            game = gameName;
        }

        //try asset
        if (assetPath) {
            game = assetPath;
        }

        return (
            game && (
                <div className='game-content'>
                    <iframe
                        title={game}
                        src={`https://d34p974oq0f6d.cloudfront.net/${game}/index.html`}
                        frameBorder='0'
                        ref={(f) => (this.ifr = f)}
                        id='student-games'
                        width='100%'
                        height='100%'
                    />
                </div>
            )
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAddAlert: (message) => dispatch(addAlert(message)),
        dispatchAddToScore: (type, score) => dispatch(addToScore(type, score)),
        dispatchSubtractFromScore: (type, score) => dispatch(subtractFromScore(type, score)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withActivityAnalytics(GameActivity)));
